<script setup lang="ts">
import type { RentingProduct } from './CartRenting.vue'
import type { Variant } from '~/types/product.type'

interface Props {
  rentingProduct: RentingProduct
  isLoading: boolean
  deposit: number
}

const props = defineProps<Props>()
const selectedProducts = defineModel<Variant[]>({
  required: true,
})
const { t } = useI18n()
const isSelected = ref<boolean>(isSelectedProduct(props.rentingProduct))

function isSelectedProduct(product: RentingProduct) {
  return selectedProducts.value.find(x => x?.id === product.id) !== undefined
}

function onSelectProduct(product: RentingProduct) {
  if (isSelectedProduct(product)) {
    selectedProducts.value = selectedProducts.value.filter(x => x?.id !== product.id)
    return
  }

  selectedProducts.value = [...selectedProducts.value, product.variant]
}

watch(isSelected, () => {
  onSelectProduct(props.rentingProduct)
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex lg:gap-8 lg:items-center flex-col lg:flex-row">
      <div class="w-24 h-24 flex-none rounded object-contain bg-white">
        <img v-if="rentingProduct.image" :src="rentingProduct.image" alt="" class="w-full h-full object-contain">
        <Logo v-else class="w-full h-full object-contain px-4" />
      </div>
      <div class="flex flex-col lg:flex-row justify-between gap-4 w-full lg:items-center">
        <div class="flex-1 flex flex-col gap-2">
          <div class="text-lg font-bold">
            {{ rentingProduct.title }}
          </div>
          <div class="">
            <label class="select-none cursor-pointer flex items-center gap-4">
              <input
                v-model="isSelected"
                :disabled="isLoading"
                class="border-1 appearance-none border-primary focus:ring-primary cursor-pointer text-primary-light checkmark-gray h-8 w-8 cursor-pointer rounded-lg focus:ring-2 focus:ring-yellow-400 disabled:opacity-50"
                type="checkbox"
              >
              <div class="flex flex-row gap-1 items-center">
                {{ $t('cart.rent') }}
                <Transition name="fade">
                  <IconLoader v-if="isLoading" color="primary" class="w-4 h-4" />
                </Transition>

              </div>

            </label>
          </div>
        </div>
        <div>
          <div class="text-primary text-lg font-bold">
            {{ t('cart.renting') }}:
            {{ formatCurrency(rentingProduct.basePrice / 100) }}
            <span class="text-xs text-gray-500">
              ({{ $t('cart.incl_btw') }})
            </span>
          </div>
          <div class="text-sm">
            {{ t('cart.deposit') }}:
            {{ formatCurrency(deposit / 100) }}
            <span class="text-xs text-gray-500">
              ({{ $t('cart.excl_btw') }})
            </span>
          </div>
        </div>
      </div>
    <!-- <div class="flex gap-2">

        </div> -->
    </div>
  </div>
</template>
